export enum CommunicationRecordTargetType {
  Activity = 1,

  ProjectIntake = 2,

  /** Whole-project attachment pool, used to resolve compose attachments before a ProjectIntake exists yet. */
  CompanyProject = 3
  // Future:
  // Invoice = 4,
}
